.n{justify-content:center;}